import { render, staticRenderFns } from "./CreateNotificationContent.vue?vue&type=template&id=f5a15a84&scoped=true&"
import script from "./CreateNotificationContent.vue?vue&type=script&lang=js&"
export * from "./CreateNotificationContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateNotificationContent.vue?vue&type=style&index=0&id=f5a15a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a15a84",
  null
  
)

export default component.exports